import { em } from 'polished'
import styled from 'styled-components'

export const Wrapper = styled.div`
  color: ${p => p.theme.colors.white};
  padding: 0 ${p => p.theme.indents.baseBoxIndentLg} ${em(300)};
  position: relative;
  display: flex;
  overflow: hidden;
`

export const ScenesDurationsWrapper = styled.div`
  position: absolute;
  width: 100%;
  left: 0;
`

export const ScenesDuration = styled.div`
  height: 100vh;
  position: relative;
`

export const Inner = styled.div`
  width: 37%;
  height: 0;
`

export const DifferenceBox = styled.div`
  width: 37%;
  padding-bottom: ${em(140)};
  opacity: 0.2;
  transition: opacity 300ms ease-out;

  &.active {
    opacity: 1;
  }
`

export const DifferenceInner = styled.div`
  width: ${em(305)};
`

export const Diff = styled.div`
  color: ${p => p.theme.colors.purpleHeart};
  font-size: ${em(60)};
`

export const IndicatorsBox = styled.div`
  position: absolute;
  width: calc(100% - ${em(80)});
  top: 0;
`
